if (!customElements.get('ns-photo-review-gallery')) {
  customElements.define('ns-photo-review-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.cards = [...this.querySelectorAll('.ns-photo-review')];
      this.dialog = this.querySelector('dialog');
      this.more = this.querySelector('[data-review-load-more]');
      if (!this.cards.length || !this.dialog || !this.more) return;
      this.filter = 'all';
      this.visibleCount = 3;
      this.more.addEventListener('click', () => {
        const matches = this.matchingCards();
        const collapsing = this.visibleCount >= matches.length;
        const next = collapsing ? matches[0] : matches[this.visibleCount];
        this.visibleCount = collapsing ? 3 : this.visibleCount + 3;
        this.updateList();
        next?.focus({ preventScroll: true });
        next?.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }, { signal });
      this.querySelectorAll('[data-review-filter]').forEach(button => {
        button.addEventListener('click', () => {
          this.filter = button.dataset.reviewFilter;
          this.visibleCount = 3;
          this.querySelectorAll('[data-review-filter]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
          this.updateList();
        }, { signal });
      });
      this.addEventListener('click', event => {
        const opener = event.target.closest('[data-review-open], [data-gallery-open], [data-gallery-index]');
        if (!opener || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        const card = opener.closest('.ns-photo-review');
        const index = card ? this.cards.indexOf(card) : Number(opener.dataset.galleryIndex || 0);
        this.returnFocus = opener;
        this.show(index);
        if (!this.dialog.open) {
          this.scrollLock = document.body.style.overflow;
          document.body.style.overflow = 'hidden';
          this.dialog.showModal();
        }
      }, { signal });
      this.querySelector('[data-gallery-close]').addEventListener('click', () => this.dialog.close(), { signal });
      this.querySelector('[data-gallery-prev]').addEventListener('click', () => this.show(this.galleryIndex - 1), { signal });
      this.querySelectorAll('[data-gallery-next]').forEach(button => button.addEventListener('click', () => this.show(this.galleryIndex + 1), { signal }));
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
      }, { signal });
      this.dialog.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.show(this.galleryIndex + (event.key === 'ArrowLeft' ? -1 : 1));
        }
      }, { signal });
      this.dialog.addEventListener('close', () => {
        document.body.style.overflow = this.scrollLock || '';
        this.returnFocus?.focus({ preventScroll: true });
      }, { signal });
      this.updateList();
      this.setAttribute('data-review-ready', '');
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      if (this.dialog?.open) document.body.style.overflow = this.scrollLock || '';
    }
    matchingCards() {
      return this.cards.filter(card => this.filter === 'all' || card.dataset.reviewKind === this.filter);
    }
    updateList() {
      const matches = this.matchingCards();
      this.cards.forEach(card => { card.hidden = !matches.includes(card) || matches.indexOf(card) >= this.visibleCount; });
      this.more.hidden = matches.length <= 3;
      const expanded = this.visibleCount >= matches.length;
      this.more.querySelector('[data-review-more-label]').textContent = expanded ? this.more.dataset.lessLabel : this.more.dataset.moreLabel;
      this.more.classList.toggle('is-expanded', expanded);
    }
    show(index) {
      this.galleryIndex = (index + this.cards.length) % this.cards.length;
      const card = this.cards[this.galleryIndex];
      const photo = card.querySelector('.ns-photo-review__photo');
      const media = this.querySelector('[data-gallery-media]');
      media.hidden = !photo;
      if (photo) {
        this.querySelector('[data-gallery-image]').src = photo.href;
        media.href = photo.href;
      }
      this.dialog.classList.toggle('ns-photo-reviews__dialog--text-only', !photo);
      this.querySelector('[data-gallery-title]').textContent = card.querySelector('h3').textContent;
      this.querySelector('[data-gallery-quote]').textContent = card.querySelector('blockquote').textContent;
      this.querySelector('[data-gallery-name]').textContent = card.querySelector('.ns-photo-review__name').textContent;
      this.querySelector('[data-gallery-stars]').replaceChildren(card.querySelector('.ns-photo-review__stars').cloneNode(true));
    }
  });
}
